//
// KPILabel.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "./KPILabelType";
import "./KPILabelPosition";

var KPILabel = createModule("BIRD::KPILabel", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        variable: 7,
        format: 7,
        position: 4,
        type: 4,
        lines: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default KPILabel;
